export default __webpack_public_path__ + "static/media/Jazz.e4bc676e.svg";